// @ts-ignore
import request, { projectRequest } from 'store/utils/request';

export const commitBranch = (message?: string) =>
  projectRequest.post(
    '/version_control/commits/',
    {
      message,
    },
    {
      timeout: 4 * 60 * 1000, // 4 minutes
    },
  );

export const pullBranch = () => projectRequest.post('/version_control/pull/');

export const checkGitStatus = () =>
  projectRequest.get('/version_control/status/');

export const checkForConflicts = () =>
  projectRequest.get('/version_control/local_change_conflicts/');

export const fetchBranches = () =>
  projectRequest.get('/version_control/branches/');

export const createBranch = (parentBranch: string, branchName: string) =>
  projectRequest.post(
    '/version_control/branches/',
    {
      branch_parent: parentBranch,
      branch_name: branchName,
    },
    {
      timeout: 4 * 60 * 1000, // 4 minutes
    },
  );

export const fetchCommits = (branch: string, page: number, size: number) =>
  projectRequest.get(`/version_control/commits/?branch=${branch}`, {
    params: { page, size },
  });

export const deleteBranch = (account: string, branch: string) =>
  request.delete(`/${account}/projects/${branch}/`);
